import { Flex } from '@chakra-ui/react';

import Box from 'shared_DEPRECATED/components/Box';
import Spacer from 'shared_DEPRECATED/components/Spacer';

import {
  GoalBreakdownEmptyState,
  GoalBreakdownBoardChallenges,
  GoalBreakdownBoardFocusAreas,
  useGoalBreakdown,
} from 'features/goal';

import { BoardColumn } from 'shared/components/Board';

export const GoalBreakdownContent = () => {
  const { challenges, focusAreas } = useGoalBreakdown();

  const isGoalBreakdownFilled = challenges.length || focusAreas.length;

  return (
    <BoardColumn>
      {!isGoalBreakdownFilled ? (
        <GoalBreakdownEmptyState />
      ) : (
        <>
          <Box style={{ width: '100%', height: '100%' }}>
            <Spacer size="sm" height="100%">
              <Flex flexDirection="column" height="100%" gap="var(--spacing01)">
                <GoalBreakdownBoardFocusAreas />
                <Flex grow={1} shrink={0} flexDirection="column">
                  <GoalBreakdownBoardChallenges />
                </Flex>
              </Flex>
            </Spacer>
          </Box>
        </>
      )}
    </BoardColumn>
  );
};
